<template>
  <div>
    <b-card-header>
      <b-row>
        <b-col>
<!--          <a-->
<!--            target="_blank"-->
<!--            :href="`http://www.uniauc.com/admin/${$route.params.parentTable}_list.php?receive_nation=&status=&act=search&searchKey=idx%3B${$route.params.parentTable}&searchVal=${fee.idx}&searchType=perfect`"-->
<!--            >-->
<!--          <font-awesome-icon icon="link"  />-->
<!--          </a>-->

          <b-modal
            v-if="openModalIdx === fee.idx"
            id="parentEditModal"
            hide-footer
            title="Parent Edit"
            size="lg"
            @ok="onParentEdit(fee, tab)"
          >
            <b-form @submit.prevent="onParentEdit(fee, tab)">
              <b-row>
                <b-col
                  v-for="field of editFormParent"
                  :key="field.key"
                  xs="12"
                  sm="6"
                  description=""
                >
                  <label :for="field.key">
                    {{ (field.text ? field.text : field.key).toUpperCase() }}
                  </label>

                  <b-form-input
                    :id="field.key"
                    v-model.trim="field.value"
                    placeholder=""
                    @change="pushParentChange(fee, field.key, $event, tab)"
                  />
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <b-btn-group>
                    <b-btn variant="primary" type="submit"> OK</b-btn>
                    <b-btn
                      variant="warning"
                      @click="$bvModal.hide('parentEditModal')"
                    >
                      CANCEL
                    </b-btn>
                    <b-btn variant="danger" @click="clearParentFields()">
                      CLEAR
                    </b-btn>
                  </b-btn-group>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>

          <font-awesome-icon
            v-if="['logis','fees'].includes(tab.parentTable)"
            icon="edit"
            @click="parentEdit(fee)"
          />
          {{ fee.region }}
          [<a
            style="cursor: pointer"
            :id="fee.idx"
            @click="getChangeLog('logis', fee.idx)"
            >{{ fee.idx }}</a
          >]
          <b-badge>{{ getSimpleDate(fee.writeday) }}</b-badge>
          <b-badge
            v-if="$route.params.parentTable === 'fees' && fee.paid === -1"
            variant="danger"
          >
            Unpaid
          </b-badge>
          <b-badge
            v-else-if="$route.params.parentTable === 'logis' && fee.paid === 2"
            variant="success"
          >
            Paid </b-badge
          >&nbsp;
          <b-badge v-if="fee.userid === 'glomarketb'" variant="danger">
            {{ fee.userid }}
          </b-badge>
          <span v-else @click="searchUser">{{ fee.userid }}</span>
          {{ fee.feecode }}
          {{ fee.logicode }}
          <a target="_blank" :href="getCarrierLink(fee)">
            <b-badge v-if="fee.carrier" variant="info"
              >{{ fee.carrier.toUpperCase() }}
            </b-badge>
            <b-badge v-if="fee.carrier" variant="info">
              {{ fee.weight }}
            </b-badge>
          </a>
          {{ fee.tnum }}
          <b-btn-group>
            <b-btn @click="printBL(fee)">print</b-btn>
            <b-btn variant="info" @click="printInvoice(fee)">Invoice </b-btn>
            <b-btn v-if="fee.countryId === 3" @click="printAwb(fee, 'yye')">
              YY Print
            </b-btn>
          </b-btn-group>

          <span>
            <span v-if="fee.status === 0">
              🎬[주문대기중]
            </span>
            <span v-if="fee.status === 1">
              ❗[오류처리중]
            </span>
            <span v-if="fee.status === 2">
              🚚[현지배송중] <b-badge variant="warning">Bought</b-badge>
              {{ fee.procuredAt }}
            </span>
            <span v-if="fee.status === 3">
              🚚[현지배송중] <b-badge variant="warning">Bought</b-badge>
              {{ fee.procuredAt }}
            </span>
            <span v-if="fee.status === 4">
              🏤[현지도착] <b-badge variant="danger">Arrived</b-badge>
              {{ fee.arriveday }}
            </span>
            <span v-if="fee.status === 5">
              <span class="text-success">⬤</span>
              <b-badge variant="success">Shipped</b-badge>
              {{ fee.shipday }}
            </span>
            <span v-if="fee.defer === 2"> Deferred: {{ fee.deferday }} </span>
            <span v-if="fee.defer === 5"> Scanned: {{ fee.scanday }} </span>
          </span>
          <b-btn-group class="ml-2">
            <b-btn
              v-if="$route.params.parentTable === 'logis'"
              @click="copy(fee.idx, 2)"
            >
              Copy
            </b-btn>
            <b-btn
              variant="primary"
              v-if="$route.params.parentTable === 'logis'"
              @click="copy(fee.idx, 4, 'stockUS')"
            >
              Stock
            </b-btn>
            <b-btn
              variant="warning"
              v-if="$route.params.parentTable === 'logis'"
              @click="extract"
            >
              Divide
            </b-btn>
          </b-btn-group>
        </b-col>
        <h5 v-if="fee.currentState">
          <b-badge variant="info">
            {{ fee.currentState }}
          </b-badge>
        </h5>
        <b-col
          v-if="fee.status < 5 && fee.feecode && tab.parentTable === 'fees'"
          v-show="!fee.currentState"
          class="text-right"
        >
          <b-btn
            v-if="fee.orders[0].paid === -1"
            variant="success"
            @click="
              submit('confirm', { feecode: fee.feecode }, fee, fee.orders)
            "
          >
            Confirm
          </b-btn>
          <b-btn
            type="button"
            variant="secondary"
            @click="
              submit(
                'partialRetry',
                { feecode: fee.feecode },
                fee,
                fee.orders,
                fee,
              )
            "
          >
            Partial Retry
          </b-btn>
          <b-btn
            type="button"
            variant="info"
            @click="
              submit(
                'retry',
                {
                  feecode: fee.feecode,
                  idxs: fee.orders.map((order) => order.idx),
                },
                fee,
                fee.orders,
                fee,
              )
            "
          >
            Retry All
          </b-btn>
          <b-btn
            type="button"
            variant="warning"
            @click="
              submit(
                'cancel',
                {
                  feecode: fee.feecode,
                  idxs: fee.orders.map((order) => order.idx),
                },
                fee,
                fee.orders,
              )
            "
          >
            Cancel All
          </b-btn>
        </b-col>
        <b-col v-if="$route.query.status === '3'" class="text-right">
          <b-btn
            type="button"
            variant="success"
            @click="
              submit(
                'shipped',
                {
                  feecode: fee.feecode,
                  idxs: fee.orders.map((order) => order.idx),
                },
                fee,
                fee.orders,
              )
            "
          >
            All shipped
          </b-btn>
          <b-btn
            type="button"
            variant="danger"
            @click="
              submit(
                'canceled',
                {
                  feecode: fee.feecode,
                  idxs: fee.orders.map((order) => order.idx),
                },
                fee,
                fee.orders,
              )
            "
          >
            All canceled
          </b-btn>
        </b-col>
        <b-col cols="1">
          <span v-if="fee.defer !== 2 && fee.defer < 5 && fee.status < 5">
            <b-form @submit.prevent="onWeightSubmit(fee)">
              <b-input v-model="fee.weight" placeholder="Weight"></b-input>
            </b-form>
          </span>
        </b-col>
        <b-col cols="2">
          <b-radio-group
            v-model.trim="fee.region"
            placeholder=""
            button-variant="outline-primary"
            @click.native="onClickRegion(fee, $event)"
            buttons
          >
            <b-radio value="US">US</b-radio>
            <b-radio value="CN">CN</b-radio>
          </b-radio-group>
        </b-col>
      </b-row>
      <b-row v-if="fee.desc">{{ fee.desc }}</b-row>
      <b-row v-if="fee.savemsg">{{ fee.savemsg }}</b-row>
      <b-row>
        <!--        <b-btn v-if="$route.params.parentTable==='logis'">cancel</b-btn>-->
        <!--        <b-button-group>-->
        <!--          <b-dropdown right text="Cancel">-->
        <!--            <b-dropdown-item @click="cancel('customerRequest')">Customer requested</b-dropdown-item>-->
        <!--            <b-dropdown-item @click="cancel('notArrived')">Item not arrived</b-dropdown-item>-->
        <!--          </b-dropdown>-->
        <!--        </b-button-group>-->
        <!--        <b-btn v-if="$route.params.parentTable==='logis'" @click="$bvModal.show('refundModal')">Partial Refund</b-btn>-->

        <b-col
          cols="3"
          v-if="fee.status === -1 && fee.countryCode === 'KR'"
          :class="{
            'bg-success': fee.currentState === 'changed',
          }"
        >
          <b-btn size="sm" variant="success" @click="modifyId(fee)">
            Modify ID
          </b-btn>
          <b-btn
            size="sm"
            variant="danger"
            @click="updateLogis(fee, { defer: 14, status: -1 })"
          >
            Unreachable
          </b-btn>
        </b-col>
        <b-col cols="9" v-show="[-1, 5].includes(fee.status)">
          {{ fee.name }}
          <b-badge variant="warning">{{ fee.hand }}</b-badge>
          {{ fee.idno }} {{ fee.adr1 }} {{ fee.adr2 }} {{ fee.city }}
          {{ fee.province }} {{ fee.zip }} {{ fee.countryCode }}
          {{ fee.email }}
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body class="mp-0">
      <b-checkbox-group v-model="checkedItems">
        <!--          You need v-if because when you click empty checkbox before the loading, [true] along with the idx value will be posted when submit the form.-->
        <b-row
          v-for="(order, orderIndex) of fee.orders"
          v-if="order.idx > 0"
          :key="order.idx"
          class="border-bottom mt-1"
        >
          <b-col cols="1" class="text-center">
            <span>
              <b-checkbox :value="order.idx" />
            </span>
            <span>
              <div>
                <a
                  target="_blank"
                  :href="
                    'http://www.uniauc.com/admin/logis_list.php?receive_nation=&status=&act=search&searchKey=idx%3Borders&searchVal=' +
                    order.idx +
                    '&searchType=perfect'
                  "
                >
                  <b-img
                    rounded
                    width="80"
                    height="80"
                    :src="showImg(order.img)"
                  />
                </a>
              </div>
              <div>
                <div>
                  <h4 v-if="order.status === 0">
                    <b-badge variant="secondary">Pending</b-badge>
                  </h4>
                  <h4 v-if="order.status === 1">
                    <b-badge variant="info">Errored</b-badge>
                  </h4>
                  <h4 v-if="order.status === 2">
                    <b-badge variant="primary">Bought</b-badge>
                  </h4>
                  <h4 v-if="order.status === 3">
                    <b-badge variant="primary">Bought</b-badge>
                  </h4>
                  <h4 v-if="order.status === 4">
                    <b-badge variant="danger">Arrived</b-badge>
                  </h4>
                  <h4 v-if="order.status === 5">
                    <b-badge variant="success">Shipped</b-badge>
                  </h4>
                  <h4 v-if="[6, 7].includes(order.status)">
                    <b-badge variant="warning">Cancelled</b-badge>
                  </h4>
                </div>
              </div>
            </span>
          </b-col>
          <b-col cols="7" :class="'bg-' + stateColors[order.status]">
            <div />
            <b-modal
              v-if="openModalIdx === order.idx"
              id="editModal"
              hide-footer
              title="Edit"
              size="lg"
              @ok="onEdit(fee, tab)"
            >
              <b-form @submit.prevent="onEdit(fee, tab)">
                <b-row>
                  <b-col
                    v-for="{ name, key: fieldKey } of editGroup"
                    :key="fieldKey"
                    xs="12"
                    sm="6"
                    description=""
                  >
                    <b-modal
                      v-if="openBulkModalKey === fieldKey"
                      id="bulkEditModal"
                      @ok="onEdit(fee, tab)"
                    >
                      <b-form>
                        <b-form-group
                          v-for="(order, id) of tab.parents.find(
                            (parent) => parent.idx === fee.idx,
                          ).orders"
                          :key="id"
                          description=""
                        >
                          <label :for="order.idx + ''">
                            [{{ order.idx }}] {{ fieldKey }}
                          </label>
                          <b-form-input
                            :id="order.idx + ''"
                            v-model.trim="order[fieldKey]"
                            placeholder=""
                            @change="
                              pushChangeBulk(
                                fieldKey,
                                $event,
                                tab.parents.find(
                                  (parent) => parent.idx === fee.idx,
                                ).orders,
                              )
                            "
                          />
                        </b-form-group>
                      </b-form>
                    </b-modal>

                    <label :for="fieldKey">
                      {{ (name ? name : fieldKey).toUpperCase() }}
                      <b-badge @click="bulkEdit(fieldKey, fee, tab)"
                        >More
                      </b-badge>
                      <span v-if="fieldKey === 'costTotal'">
                        (Discount
                        {{ (order.priceSum - order.costTotal).toFixed(2) }})
                      </span>
                    </label>
                    <b-form-input
                      :id="fieldKey"
                      v-model.trim="order[fieldKey]"
                      placeholder=""
                      @change="pushChange(order, fieldKey, $event)"
                    />
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <b-input v-model="splitQty" />
                  </b-col>
                  <b-col>
                    <b-btn @click="split(order.idx, tab)"> Split</b-btn>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <b-input v-model="newQty" />
                  </b-col>
                  <b-col>
                    <b-btn
                      @click="
                        changeQty(
                          tab.parents
                            .find((parent) => parent.idx === fee.idx)
                            .orders.find((child) => child.idx === order.idx),
                        )
                      "
                    >
                      Change QTY
                    </b-btn>
                  </b-col>
                </b-row>

                <b-row class="mt-3">
                  <b-col>
                    <b-btn type="submit"> OK</b-btn>
                  </b-col>
                </b-row>
              </b-form>
            </b-modal>

            <font-awesome-icon icon="edit" @click="edit(order)" />

            <a
              class="mx-1"
              style="cursor: pointer"
              :id="order.idx"
              @click="getChangeLog('orders', order.idx)"
            >
              <i class="fa fa-sticky-note"></i
            ></a>
            [{{ order.idx }}]

            <b-badge
              class="mr-1"
              :variant="order.cnt > 1 ? 'warning' : 'secondary'"
            >
              {{ order.cnt }}
            </b-badge>
            <b-badge
              v-if="[-1, -2].includes(order.paid)"
              variant="danger"
              class="mr-2"
            >
              unpaid
            </b-badge>
            <b-badge
              v-if="[-3].includes(order.paid)"
              variant="danger"
              class="mr-2"
            >
              Refunded
            </b-badge>
            <a target="_blank" :href="order.url">
              <span
                class="text-secondary"
                :style="{
                  'text-decoration': [2, 3].includes(order.status)
                    ? 'text-light'
                    : '',
                  'text-decoration':
                    [6, 7].includes(order.status) ||
                    [-4, -3].includes(order.paid)
                      ? 'line-through'
                      : '',
                }"
                >{{ order.title }}</span
              >
            </a>
            <div>
              <span > 마켓 노출명: </span>
              <b>{{ order.cloneTitle }}</b>
            </div>
            <div>
              <span > 마켓 옵션: </span>
              {{ order.size }}
            </div>
            <div>
              <span > 공급처 옵션: </span>
              {{ order.color }}
            </div>
            {{ order.category }} {{ order.hscode }}<br />
            <a
              v-if="order.titleOrg.startsWith('http')"
              target="_blank"
              :href="order.titleOrg"
            >
              <span
                :style="{
                  'text-decoration': [2, 3].includes(order.status)
                    ? 'text-light'
                    : '',
                  'text-decoration': [6, 7].includes(order.status)
                    ? 'line-through'
                    : '',
                }"
                >{{ order.titleOrg }}</span
              ></a
            >
            <div>
              {{ order.deliverydate_info }}
            </div>
            {{ order.trade_id }}
            {{ order.idcode }}
            {{ order.marketId }}
              <b-badge variant="info">{{ order.itemCode }}</b-badge>
            <div
              :style="{
                color: order.status !== 1 ? 'grey' : '',
              }"
            >
              {{ order.error }}
            </div>
            <div v-if="[2, 3].includes(order.status)">
              Arrives in
              <input
                v-model="order.arrivesIn"
                class="mx-2"
                style="width: 50px"
              />
              <b-badge variant="success">{{ order.tnum }}</b-badge>
            </div>
            <div>
              <b-btn
                size="md"
                variant="danger"
                @click="ban(order)"
                v-if="fee.region !== 'US'"
                >drop item
              </b-btn>
              <b-btn
                size="md"
                variant="danger"
                v-if="fee.region !== 'US'"
                @click="banSeller(order)"
                >drop seller
              </b-btn>
              <b-btn
                variant="warning"
                v-if="fee.status < 4"
                @click="
                  submit('cancel', { idxs: [order.idx] }, order, fee.orders)
                "
              >
                Cancel
              </b-btn>
              <b-btn
                size="sm"
                variant="success"
                @click="unban(order)"
                v-if="fee.region !== 'US'"
                >Undrop item
              </b-btn>
              <b-btn
                size="sm"
                variant="success"
                v-if="fee.region !== 'US'"
                @click="unbanSeller(order)"
                >Undrop seller
              </b-btn>
            </div>
          </b-col>
          <b-col>
            <b-modal :id="'costFormula' + order.idx" size="xl">
              <b-table-simple responsive>
                <b-thead>
                  <b-tr>
                    <b-th>Total (x{{ order.cnt }}) Item Charge</b-th>
                    <b-th>Total Shippng Charge</b-th>
                    <b-th
                      >Total Shipping Cost ({{ order.estWeight }}kg x
                      {{ order.cnt }})</b-th
                    >
                    <b-th>Total Revenue for {{ order.cnt }} Items</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr>
                    <b-td>{{ order.revenue * order.cnt }}</b-td>
                    <b-td>{{ order.proratedShipFee * order.cnt }}</b-td>
                    <b-td>{{ -order.proratedShipCost * order.cnt }}</b-td>
                    <b-td class="text-primary"
                      >{{
                        (order.revenue +
                          order.proratedShipFee -
                          order.proratedShipCost) *
                        order.cnt
                      }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <b-table-simple responsive>
                <b-thead>
                  <b-tr>
                    <b-th>Unit Item Charge</b-th>
                    <b-th>Unit Shipping Charge</b-th>
                    <b-th>Unit Shipping Cost</b-th>
                    <b-th>Unit Item Revenue</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr>
                    <b-td>{{ order.revenue }}</b-td>
                    <b-td>{{ order.proratedShipFee }}</b-td>
                    <b-td
                      >{{
                        order.proratedShipCost
                          ? -order.proratedShipCost.toFixed(2)
                          : null
                      }}
                    </b-td>
                    <b-td class="text-primary"
                      >{{
                        (
                          order.revenue +
                          order.proratedShipFee -
                          order.proratedShipCost
                        ).toFixed(2)
                      }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <b-table-simple responsive>
                <b-thead>
                  <b-tr>
                    <b-th>FX rate</b-th>
                    <b-th>Maximum Unit Item cost</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr>
                    <b-td
                      >{{ order.fxRate ? order.fxRate.toFixed(2) : null }}
                    </b-td>
                    <b-td class="text-danger">
                      {{
                        (
                          (order.revenue +
                            order.proratedShipFee -
                            order.proratedShipCost) /
                          order.fxRate
                        ).toFixed(2)
                      }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-modal>
            <b-badge v-if="order.cnt > 1" variant="primary">{{ "x1" }}</b-badge>
            <span v-if="order.region === 'US'"> {{ order.price }}</span>
            ({{ getCurrencyUnit(order.targetRegion) }}{{ order.revenue }} +
            {{ order.proratedShipFee }} -
            {{
              order.proratedShipCost ? order.proratedShipCost.toFixed(2) : null
            }}
            =
            {{
              (
                order.revenue +
                order.proratedShipFee -
                order.proratedShipCost
              ).toFixed(2)
            }}
            / {{ order.fxRate ? order.fxRate.toFixed(2) : null }} =
            <b v-if="order.estWeight">
              {{
                (
                  (order.revenue +
                    order.proratedShipFee -
                    order.proratedShipCost) /
                  order.fxRate
                ).toFixed(2)
              }}
            </b>
            <b v-else> no weight </b>
            )
            <!--                                    {{order.fxRate}}-->
            <div v-if="order.cnt > 1">
              <b-badge variant="danger">{{ "x" + order.cnt }}</b-badge>
              <span v-if="order.region === 'US'">
                {{ order.price * order.cnt }}</span
              >
              ({{ getCurrencyUnit(order.targetRegion)
              }}{{ order.revenue * order.cnt }} +
              {{ order.proratedShipFee * order.cnt }} -
              {{
                order.proratedShipCost * order.cnt
                  ? (order.proratedShipCost * order.cnt).toFixed(2)
                  : null
              }}
              =
              {{
                (
                  order.revenue * order.cnt +
                  order.proratedShipFee * order.cnt -
                  order.proratedShipCost * order.cnt
                ).toFixed(2)
              }}
              / {{ order.fxRate ? order.fxRate.toFixed(2) : null }} =
              <b v-if="order.estWeight">
                {{
                  (
                    (order.revenue * order.cnt +
                      order.proratedShipFee * order.cnt -
                      order.proratedShipCost * order.cnt) /
                    order.fxRate
                  ).toFixed(2)
                }}
              </b>
              <b v-else> no weight </b>
              )
            </div>
            <b-btn size="sm" @click="$bvModal.show('costFormula' + order.idx)"
              >Formula
            </b-btn>
            <div class="mt-2">
              <b-input-group prepend="weight">
                <b-input
                  v-model="order.estWeight"
                  @keyup="calcShipCost(order)"
                  @change="pushChange(order, 'estWeight', $event)"
                />
              </b-input-group>
            </div>
          </b-col>
          <b-col
            :class="{
              'bg-success': ['bought', 'changed'].includes(order.currentState),
            }"
          >
            <b-row>
              <b-col v-if="order.currentState">
                <h1>
                  <b-badge>
                    {{ order.currentState }}
                  </b-badge>
                </h1>
              </b-col>
            </b-row>

            <b-row class="mb-2" v-show="[2, 3, 4].includes(order.status)">
              <b-col xs="6" description="">
                <b-form-input
                  v-model.trim="order.hscode"
                  @change="changeHScode(order)"
                />
              </b-col>
              <b-col xs="6" description="">
                <b-form-input
                  v-model.trim="order.arrivesAt"
                  @change="changeArrivesAt(order)"
                />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-btn-group v-if="fee.feecode">
                  <!-- if you retry minimum order or cannot be shipped order, auto buyer will infinitely repeat the buying process -->
                  <b-btn
                    v-if="order.paid !== -1 && order.status < 2"
                    v-show="
                      !order.error.match(
                        /minimum order|cannot be shipped|not enough/,
                      )
                    "
                    variant="info"
                    @click="
                      submit(
                        'retry',
                        { idxs: [order.idx] },
                        order,
                        fee.orders,
                        fee,
                      )
                    "
                  >
                    Force
                  </b-btn>
                  <b-btn
                    v-if="order.paid !== -1 && order.status < 2"
                    variant="success"
                    @click="
                      submit(
                        'bought',
                        { idxs: [order.idx] },
                        order,
                        fee.orders,
                        fee,
                      )
                    "
                  >
                    Bought
                  </b-btn>
                  <!--                <b-btn v-if="order.userid === 'rakuten'" :pressed.sync="order.currentState === 'canceled'"-->
                  <!--                       variant="danger"-->
                  <!--                       @click="submit('canceled',{idxs:[order.idx]},order,fee.orders)">-->
                  <!--                  delete-->
                  <!--                </b-btn>-->
                  <b-btn
                    variant="warning"
                    @click="
                      submit('cancel', { idxs: [order.idx] }, order, fee.orders)
                    "
                  >
                    Cancel
                  </b-btn>
                </b-btn-group>
                <b-btn-group
                  v-if="$route.query.status === '3'"
                  v-show="!order.currentState"
                >
                  <b-btn
                    variant="info"
                    @click="
                      submit('retry', { idxs: [order.idx] }, order, fee.orders)
                    "
                  >
                    Retry
                  </b-btn>
                  <b-btn
                    variant="success"
                    @click="
                      submit(
                        'shipped',
                        { idxs: [order.idx] },
                        order,
                        fee.orders,
                      )
                    "
                  >
                    Shipped
                  </b-btn>
                  <b-btn
                    variant="warning"
                    @click="
                      submit('cancel', { idxs: [order.idx] }, order, fee.orders)
                    "
                  >
                    Cancel
                  </b-btn>
                  <b-btn
                    variant="danger"
                    @click="
                      submit(
                        'canceled',
                        { idxs: [order.idx] },
                        order,
                        fee.orders,
                      )
                    "
                  >
                    Canceled
                  </b-btn>
                </b-btn-group>
                <!--        Current:-->
                <!--        <b-btn>{{order.currentState}}</b-btn>-->
              </b-col>
            </b-row>
            <b-row v-if="!order.currentState && [0, 1].includes(order.status)">
              <b-col>
                (Discount
                {{ (order.priceSum - order.costTotal).toFixed(2) }})
                <b-row class="mb-2">
                  <b-col
                    v-for="{ name, key: fieldKey } of editGroupIssues"
                    :key="fieldKey"
                    :placeholder="name"
                    xs="12"
                    sm="6"
                    description=""
                  >
                    <b-form-input
                      :id="fieldKey"
                      v-model="order[fieldKey]"
                      :placeholder="name"
                      @change="pushChange(order, fieldKey, $event)"
                    />
                    <!--                          <b-form-input-->
                    <!--                            :id="fieldKey"-->
                    <!--                            v-model.trim="order[fieldKey]"-->
                    <!--                            :placeholder="name"-->
                    <!--                            @change="pushChange(order, fieldKey, $event)"-->
                    <!--                          />-->
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-checkbox-group>
    </b-card-body>
  </div>
</template>

<script>
const axios = require("axios");
import searchFields from "./order-fields.json";

export default {
  name: "OrderList",
  components: {},
  data() {
    const favoriteFields = [
      { text: "User ID", value: "userid;logis" },
      { text: "User ID", value: "userid;fees" },
      { text: "User ID", value: "userid;orders" },
      { text: "Package No", value: "idx;logis" },
      {
        text: "Order No",
        value: "idx;orders",
      },
      { text: "Recipient Name", value: "name;logis" },
    ];
    const optionalFields = searchFields.map((key) => ({
      text: key,
      value: key,
    }));
    const allFields = favoriteFields.concat(optionalFields);
    return {
      show: { adr: false },
      searchFields,
      pages: [],
      showSummary: false,
      perPage: 20,
      perPages: [20, 50, 100, 200, 300].map((perPage) => {
        return {
          text: "Show " + perPage,
          value: perPage,
        };
      }),
      openBulkModalKey: "",
      openModalIdx: 0,
      currentTab: 0,
      changeLogs: [],
      changeLogFields: [
        {
          key: "createdAt",
          label: "Time",
          stickyColumn: true,
          isRowHeader: true,
        },
      ],
      allFields,
      parentTables: [
        { value: "fees", text: "domestic" },
        { value: "logis", text: "shipping" },
        { value: "orders", text: "orders" },
      ],
      regions: ["US", "CN", "DE", "JP", ""],
      checkedItems: [],
      newQty: 0,
      splitQty: 0,
      splitIdx: 0,
      stateColors: {
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
      },
      currentBulkKey: "",
      currentOrder: {},
      currentId: 0,
      form: {
        // url: "",
        // cnt: "",
        price: "",
        // charge: ""
      },
      //TODO: Later change the DB and make declaredUnitPrirce,marketTotalPrice,discountedTotalPrice
      //the discount will be marketTotalPrice-declaredTotalPrice
      editFormParent: [
        { name: "Country", key: "region" },
        { key: "name", text: "Name", value: "" },
        { key: "hand", text: "Phone", value: "" },
        { key: "adr1", text: "address 1", value: "" },
        { key: "adr2", text: "address 2", value: "" },
        { key: "city", text: "city", value: "" },
        { key: "province", text: "province", value: "" },
        { key: "zip", text: "zip code", value: "" },
        { key: "countryCode", text: "country code", value: "" },
        { key: "idno", text: "ID Number", value: "" },
        { key: "tnum", text: "HBL No", value: "" },
        { key: "email", text: "email", value: "" },
        { key: "managermemo", text: "Manager memo", value: "" },
        { key: "desc", text: "Packing memo", value: "" },
        { key: "memo", text: "Delivery memo", value: "" },
        { key: "errmemo", text: "Issue", value: "" },
      ],
      editGroupParent: [
        { name: "Country", key: "region" },
        { name: "Name", key: "name" },
        { name: "Phone", key: "hand" },
        { name: "address 1", key: "adr1" },
        { name: "address 2", key: "adr2" },
        { name: "city", key: "city" },
        { name: "province", key: "province" },
        { name: "zip code", key: "zip" },
        { name: "country code", key: "countryCode" },
        { name: "ID Number", key: "idno" },
        { name: "HBL No", key: "tnum" },
        { name: "email", key: "email" },
        { name: "Defer status", key: "defer" },
        { name: "Internal memo", key: "savemsg" },
        { name: "Packing memo", key: "desc" },
      ],
      editGroupIssues: [
        { name: "Discounted Total Price", key: "costTotal" },
        { name: "Order No.", key: "trade_id" },
      ],
      editGroupCN: [{ name: "HS Code", key: "hscode" }],
      editGroup: [
        { name: "Country", key: "region" },
        { name: "Declared unit price", key: "price" },
        { name: "Qty", key: "cnt" },
        { name: "Market Total Price", key: "declarePrice" },
        { name: "Estimated Weight", key: "estWeight" },
        { name: "Discounted Total Price", key: "costTotal" },
        { name: "Unit Revenue", key: "charge" },
        { name: "Market ID", key: "marketId" },
        { name: "Order No.", key: "trade_id" },
        { name: "URL", key: "url" },
        { name: "Image URL", key: "img" },
        { name: "Title", key: "title" },
        // { name: "bought Date", key: "procuredAt" },
        { name: "Alternative title", key: "titleOrg" },
        { name: "category", key: "category" },
        { name: "hs code", key: "hscode" },
        { name: "clone No.", key: "cloneSeq" },
        { name: "Delivery Info", key: "deliverydate_info" },
        { name: "Arrives At", key: "arrivesAt" },
        { key: "error" },
        { key: "status" },
        // { key: "logicode" },
        // { key: "feecode" },
        { name: "Short Tracking", key: "stnum" },
        { name: "Tracking", key: "tnum" },
      ],
      fields: [
        "actions",
        "idx",
        "name",
        "hand",
        "adr",
        "weight",
        "carrier",
        "writeday",
      ],
      page: 1,
      filter: "",
      historyFilter: "",
      currentPage: 1,
      current: [],
      items: [],
      currentFields: {
        img: {},
        title: {
          sortable: true,
        },
        size: {},
        qty: {
          sortable: true,
        },
      },
      total: 0,
      stockData: "",
    };
  },
  props: ["fee", "tab",'rates'],
  computed() {
    return {
      CNYUSD() {
        return this.rates.find((rate) => rate.fromCode === "CNY").rate;
      },
    };
  },

  methods: {
    getSimpleDate(date) {
      const dateStr = new Date(date).toLocaleString("ja-JP", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
      console.log(dateStr);
      return dateStr.replace(new Date().getFullYear() + "/", "");
    },
    showImg(img) {
      if (img.includes("shopping-phinf.pstatic.net"))
        return "https://api.uniauc.com/image?url=" + img;
      else return img;
    },
    clearParentFields(modalId) {
      this.editFormParent.forEach((field) => {
        field.value = "";
      });
    },
    getPage(lastIdx) {
      const tab = this.tabs[this.currentTab];
      this.$router.push({
        query: { ...this.$route.query, lastIdx, perPage: this.perPage },
      });
      console.log(lastIdx);
      this.init();
    },
    async getNextPage() {
      const tab = this.tabs[this.currentTab];
      const lastIdx = tab.parents ? tab.parents.pop().idx : "";
      const searched = await this.search(tab, lastIdx);
      if (searched) this.pages.push(lastIdx);
    },
    searchUser(userid) {
      this.tabs[this.currentTab].searchForm.searchEntities.push({
        searchField: "userid;logis",
        searchValue: userid,
        searchType: "=",
      });
      this.search(this.tabs[this.currentTab]);
    },
    async ban(order) {
      if (window.confirm("Proceed?")) {
        const { error } = await axios.post("/ban", { uid: order.itemCode });
        if (error) this.$warn(error);
        else this.$warn("banned");
      }
    },
    async unban(order) {
      if (window.confirm("Proceed?")) {
        const { error } = await axios.post("/unban", { uid: order.itemCode });
        if (error) this.$warn(error);
        else this.$warn("unbanned");
      }
    },
    async banSeller(order) {
      if (window.confirm("Proceed?")) {
        const { error } = await axios.post("/ban-seller", {
          uid: order.itemCode,
        });
        if (error) this.$warn(error);
        else this.$warn("banned");
      }
    },
    async unbanSeller(order) {
      if (window.confirm("Proceed?")) {
        const { error } = await axios.post("/unban-seller", {
          uid: order.itemCode,
        });
        if (error) this.$warn(error);
        else this.$warn("unbanned");
      }
    },
    async onWeightSubmit(logi) {
      await this.updateLogis(logi, { weight: logi.weight });
      await this.printBL(logi);
    },
    printInvoice(fee) {
      window.open(`https://api.resell.glocing.com/invoice/${fee.logicode}`);
    },
    printBL(fee) {
      if (fee.feecode)
        window.open("https://api.uniauc.com/create-sgw-awb/" + fee.feecode);
      if (fee.logicode)
        window.open("https://api.uniauc.com/create-sgw-awb/" + fee.logicode);
    },
    pushChangeObj(obj, order) {
      Object.entries(obj).forEach(([key, val]) => {
        this.pushChange(order, key, val);
      });
    },
    onClickRegion(fee, evt) {
      const region = evt.target.value;
      if (!region) return;
      console.log(region);
      let currencyRate;
      if (region === "CN") {
        currencyRate = 1 / this.CNYUSD;
      } else if (region === "US") {
        currencyRate = 1;
      }
      fee.orders.forEach((order) => {
        order.region = region;
        order.price = ((order.declarePrice * currencyRate) / order.cnt).toFixed(
          2,
        );

        order.costTotal = (order.costTotal * (1 / currencyRate)).toFixed(2) * 1;

        if (region === "CN")
          order.trade_id = `Taobao ${new Date().toLocaleDateString()}`;

        const changeObj = {
          region: region,
          price: order.price,
          trade_id: order.trade_id,
        };
        this.pushChangeObj(changeObj, order);
      });

      this.$forceUpdate();
    },
    async getChangeLog(table, idx) {
      const { data: changeLogs } = await axios.get(`/get-change-log`, {
        params: {
          id: idx,
          tableName: table,
        },
      });
      for (const changeLog of changeLogs) {
        const fields = JSON.parse(changeLog.data);
        for (const fieldKey in fields) {
          this.changeLogFields.push({
            key: fieldKey,
            label: fieldKey,
          });
          changeLog[fieldKey] = fields[fieldKey];
        }
      }
      this.changeLogs = changeLogs;

      this.$bvModal.show("changeLogModal");
    },
    async updateLogis(logi, postData) {
      const { data } = await axios.post(`/update-logis/${logi.idx}`, postData);
      if (data.msg === "ok") {
        logi.currentState = "changed";
        this.$forceUpdate();
        this.$warn("updated");
      }
    },
    modifyId({ idx, zip }) {
      const url = `https://v5.uniauc.com/submit-id/${idx}/${zip}`;
      window.open(url);
    },
    chooseRegion(region) {
      // tab.searchForm.searchEntities.push({
      //   searchField: key,
      //   searchValue: tab.searchForm.region
      // })
    },
    chooseTable(tab) {
      this.searchFields = this.allFields.filter(
        (field) =>
          field.value.includes(tab.parentTable) ||
          field.value.includes("orders"),
      );
    },
    goto(row) {
      location.href = `#${row.item.idx}`;
    },
    deleteField(searchIndex, tab) {
      tab.searchForm.searchEntities.splice(searchIndex, 1);
    },
    initializeOtherFields(tab) {
      const { searchForm } = tab;
      searchForm.statusArr = [];
      searchForm.isMarket = false;
      searchForm.region = "";
    },
    changeField(searchEntity, tab) {
      const input = searchEntity.searchValue.trim();
      if (
        // fedex
        /^\d{12}$/.test(input) ||
        // kpost
        /^6\d{12}$/.test(input)
      ) {
        searchEntity.searchField = "tnum;logis";
      } else if (/ /.test(input)) {
        searchEntity.searchField = "title;orders";
        searchEntity.searchType = "=";
      } else if (/^[a-z]{3}$/.test(input)) {
        searchEntity.searchField = "carrier;logis";
      } else if (/3\d{7}$/.test(input)) {
        searchEntity.searchField = "idx;logis";
      } else if (/5\d{7}$/.test(input)) {
        searchEntity.searchField = "idx;orders";
      } else if (/^B\w{9}$/.test(input)) {
        searchEntity.searchField = "itemCode;orders";
      } else if (/^\d{10}|[0-9-]{26}$/.test(input)) {
        searchEntity.searchField = "feecode;orders";
      } else if (/^(coupang|rakuten)$/.test(input)) {
        searchEntity.searchField = `userid;${tab.parentTable}`;
      }
      if (tab.searchForm.searchEntities.every((entity) => entity.searchValue)) {
        tab.searchForm.searchEntities.push({
          searchField: "logicode;orders",
          searchValue: "",
          searchType: "=",
        });
      }
    },
    getCarrierLink({ carrier, tnum }) {
      return `https://api.resell.glocing.com/track/${tnum}`;
    },
    async snooze() {
      const { data } = await axios.post("/order-list/snoozeBy", {});
    },
    async shipYY() {
      const { data } = await axios.post("/yy-ship");
      this.$warn(data);
    },
    async printAwb(item, carrier) {
      if (carrier === "yye")
        window.open(`https://api.uniauc.com/create-yy-awb/${item.idx}`);
    },
    async extract(tab) {
      if (!confirm("Sure?")) return false;
      this.$bvModal.hide("editModal");
      const { data } = await axios.post("extract-items", {
        idxs: this.checkedItems,
      });
      this.$warn(data);
      this.search(tab);
    },
    async copy(idx, status, userid) {
      if (!confirm("Sure?")) return false;
      const { data } = await axios.post("copy-order", {
        idx,
        status,
        userid,
      });
      this.$warn(data);
      // this.$router.push(`/order-list/logis?logicode%3Borders=${data.logicode}`);
      // this.search();
    },
    async changeQty(item) {
      this.pushChange("charge", item.charge * (item.cnt / this.newQty));
      this.pushChange("price", item.price * (item.cnt / this.newQty));
      this.pushChange("cnt", this.newQty);
    },
    async split(idx, tab) {
      this.$bvModal.hide("editModal");
      const { data } = await axios.post("split-item", {
        splitQty: this.splitQty,
        idx,
      });
      this.$warn(data);
      this.search(tab);
    },
    getCurrencyUnit(region) {
      switch (region) {
        case "KR":
          return "KR￦";
        case "JP":
          return "JP¥";
        case "CN":
          return "CN¥";
        case "US":
          return "US$";
      }
    },
    async changeHScode(order) {
      const { data } = await axios.post("/edit-order", [
        {
          idx: order.idx,
          hscode: order.hscode,
          category: order.category,
        },
      ]);
      if (data.msg === "success") {
        order.currentState = "changed";
        this.$forceUpdate();
      }
      this.$warn(data.msg);
    },
    async changeArrivesAt(order) {
      const { data } = await axios.post("/edit-order", [
        {
          idx: order.idx,
          arrivesAt: order.arrivesAt,
        },
      ]);
      if (data.msg === "success") {
        order.currentState = "changed";
        this.$forceUpdate();
      }
      this.$warn(data.msg);
    },
    pushParentChange(fee, key, evt, tab) {
      if (["name", "hand", "idno"].includes(key)) fee.idChanged = 1;
    },
    calcShipCost(order) {
      if (order.region === "CN") {
        const simpleWeight = order.logisTmpWeight || order.estWeight;
        let lastmileCost;
        if (simpleWeight < 5) lastmileCost = 0;
        else if (simpleWeight < 10) lastmileCost = 3000;
        else if (simpleWeight < 20) lastmileCost = 6000;
        else lastmileCost = 9000;

        if (!order.estWeight) order.proratedShipCost = null;
        console.log(order);
        if (order.logisTmpWeight) {
          const minimumWeight =
            order.logisTmpWeight < 1 ? 1 : order.logisTmpWeight;
          const weightProportion = order.estWeight / order.logisTmpWeight;
          console.log(minimumWeight, weightProportion, "min8imal");
          order.proratedShipCost =
            (minimumWeight * 1100 + 3300 + lastmileCost) * weightProportion;
          console.log(order.proratedShipCost, "prorated");
          console.log(minimumWeight * 1100, 3300 + lastmileCost);
          console.log(order.weight);
        }
        order.proratedShipCost =
          order.estWeight * 1100 + (3300 + lastmileCost) / order.cntTotal;
      } else {
        order.proratedShipCost =
          order.estWeight * order.unitCostFx +
          order.baseCostFx / order.cntTotal;
      }
      console.log(
        order.estWeight,
        order.unitCostFx,
        order.baseCostFx,
        order.cntTotal || order.cnt,
      );
      this.$forceUpdate();
    },
    pushChange(order, key, val) {
      if (!val) return false;
      if (key === "url") {
        if (val.includes("taobao.com")) {
          // if(order.value.includes("https://www.taobao.com")){
        }
      }
      this.$forceUpdate();
      order.changed[key] = val.trim();
    },
    pushChangeBulk(key, evt, orders) {
      orders.forEach((order) => {
        order.changed[key] = order[key];
      });
    },
    async searchNewTab(tab) {
      // cloning
      this.tabs.unshift({ ...tab });
      this.tabs[0].title = `tab ${this.tabs.length}`;
      // await this.chooseTab(this.tabs[0]);
      this.chooseTable(tab);
      this.currentTab = 0;
      this.search(this.tabs[this.currentTab]);
    },
    async onSearch(tab) {
      this.$router.push({
        path: tab.parentTable,
        query: {
          ...this.$route.query,
          searchForm: JSON.stringify(tab.searchForm),
          currentPage: this.currentPage,
          perPage: this.perPage,
        },
      });
      this.search(this.tabs[this.currentTab]);
    },
    async search(tab, idx = "") {
      if (!tab.searchForm.searchEntities[0].searchValue) {
        this.$warn("Please enter search value");
        return;
      }
      console.log(this.$route.query, "on search");
      const parentItems = await this.$getRO(`/order-list/${tab.parentTable}`, {
        params: this.$route.query,
      });
      if (!parentItems.length) {
        this.$warn("No data");
        return;
      }
      parentItems.forEach((item) => {
        item.orders.forEach((order) => {
          order.changed = {
            rate: order.currentFxRate,
          };
          order.currentState = "";
          if (order.arrivesAt) order.arrivesAt = order.arrivesAt.slice(0, 10);
        });
      });
      // tab.parents = parentItems;
      this.tabs[this.currentTab].parents = parentItems;
      this.total = parentItems.length;
      this.$forceUpdate();
      return true;
    },
    async onEdit(fee) {
      const post = fee.orders
        .map((order) => ({
          idx: order.idx,
          ...order.changed,
        }))
        .filter((order) => order !== {});
      if (post === {}) alert("nothing changed");
      else {
        const fetched=await axios.post("/edit-order", post);
        console.log(fetched)
      }
      // await this.init();
      this.$bvModal.hide("editModal");
    },
    async onParentEdit(fee, tab) {
      const selectedLogi = fee;
      const dataToSubmit = {};
      this.editFormParent.forEach((group) => {
        dataToSubmit[group.key] = group.value;
      });

      if (tab.parentTable === "logis") {
        const { data } = await axios.post(
          `/edit-logis/${selectedLogi.idx}/${selectedLogi.zip}?status=${selectedLogi.status}`,
          dataToSubmit,
        );
        console.log("warning");
        this.$warn(data.message);
        if (data.error) {
          return false;
        }
      }
      if (tab.parentTable === "fees")
        await axios.post(`/edit-fees/${selectedLogi.idx}`, dataToSubmit);
      // await this.init();
      this.editFormParent.forEach((group) => {
        selectedLogi[group.key] = group.value;
      });
      this.$bvModal.hide("parentEditModal");
      return true;
    },
    parentEdit(fee) {
      this.openModalIdx = fee.idx;
      if (fee.status === -1) {
        this.editFormParent = [
          { key: "name", text: "Name", value: "" },
          { key: "hand", text: "Phone", value: "" },
          { key: "adr1", text: "Addresss 1", value: "" },
          { key: "adr2", text: "Addresss 2", value: "" },
          { key: "zip", text: "Zip code", value: "" },
          { key: "idno", text: "ID Number", value: "" },
        ];
      } else {
        this.editFormParent = [
          { key: "name", text: "Name", value: "" },
          { key: "hand", text: "Phone", value: "" },
          { key: "adr1", text: "address 1", value: "" },
          { key: "adr2", text: "address 2", value: "" },
          { key: "city", text: "city", value: "" },
          { key: "province", text: "province", value: "" },
          { key: "zip", text: "zip code", value: "" },
          { key: "countryCode", text: "country code", value: "" },
          { key: "idno", text: "ID Number", value: "" },
          { key: "tnum", text: "HBL No", value: "" },
          { key: "email", text: "email", value: "" },
          { key: "desc", text: "Packing memo", value: "" },
          { key: "weight", text: "weight", value: "" },
          { key: "carrier", text: "carrier", value: "" },
        ];
      }
      this.editFormParent.forEach((field) => {
        field.value = fee[field.key];
      });
      this.$bvModal.show("parentEditModal");
    },
    edit(order) {
      // this.currentOrder = tab.parents[feeIndex].orders[orderIndex];
      order.changed = {};
      this.openModalIdx = order.idx;
      this.$bvModal.show(`editModal`);
    },
    bulkEdit(fieldKey, fee, tab) {
      tab.fee.orders.forEach((order) => {
        order.changed = {};
      });
      this.openBulkModalKey = fieldKey;
      this.$bvModal.show("bulkEditModal");
    },
    async submit(stateCode, params, orderOrFee, orders, fee) {
      if (!confirm("proceed?")) return false;
      // if (
      //   stateCode === "retry" &&
      //   !confirm("sure?")
      // ) {g
      //   return false;
      // }
      const { idxs, feecode } = params;
      if (fee) await this.onEdit(fee);

      const statuses = {
        partialRetry: 0,
        retry: 0,
        confirm: 0,
        bought: 2,
        arrived: 4,
        shipped: 5,
        cancel: 6,
        canceled: 7,
        delete: 7,
      };
      const status = statuses[stateCode];

      const { data } = await axios.post("/change-status", {
        safeMode:
          !this.$route.query || this.$route.query["status;orders"] === "1"
            ? 1
            : 0,
        status,
        stateCode,
        idxs,
        // logicode:orderOrFee.logicode,
        feecode,
        uid: orderOrFee.itemCode,
        countryId: orderOrFee.countryId,
        userid: orderOrFee.userid,
        orders: orders.map(({ idx, feecode, status }) => ({
          idx,
          feecode,
          status,
        })),
      });
      if (data.msg === "ok") {
        orderOrFee.currentState = stateCode;
        orderOrFee.status = status;
        this.$forceUpdate();
      }
      this.$warn(data.msg);
    },
    async init() {
      this.$nextTick(() => {
        this.search(this.tabs[this.currentTab]);
        // this.chooseTab(this.tabs[0]);
      });
    },
    async chooseTab(tab) {
      // const query = `${tab.parentTable}?searchForm=${JSON.stringify(
      //   tab.searchForm
      // )}&lastIdx=${idx}&currentPage=${this.currentPage}&perPage=${
      //   this.perPage
      // }`;
      this.chooseTable(tab);
      this.$router.push({
        path: tab.parentTable,
        query: {
          ...this.$route.query,
          searchForm: JSON.stringify(tab.searchForm),
          currentPage: this.currentPage,
          perPage: this.perPage,
          currentTab: this.currentTab,
        },
      });
    },
    async onSubmit() {
      await this.$api.post("/stock", {
        stockData: this.stockData,
      });
      this.stockData = "";
      this.init();
    },
  },
};
</script>
<style>
.modal-fullscreen .modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}

@media (min-width: 2992px) .modal-lg {
  max-width: auto !important;
}

@media (min-width: 576px) .modal-dialog {
  max-width: auto !important;
}
</style>
